import React, { useState } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import DeleteIcon from '../../../../assets/img/svg/delete-icon.svg'
import AddIcon from '../../../../assets/img/svg/add-icon.svg'
import DeletePopup from '../../../../component/deletePopup'

const TasksForm = () => {
  const { control, trigger } = useFormContext()
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'propertyTasks'
  })
  const [deleteId, setDeleteId] = useState(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const openDeleteModal = (_id) => {
    setDeleteId(_id)
    setIsDeleteModalOpen(!isDeleteModalOpen)
  }
  const onHandleDelete = () => {
    if (deleteId !== null) {
      remove(deleteId)
    }
    openDeleteModal(null)
  }

  return (
    <>
      <div className="field_scroll_div">
        <div className="row">
          {fields.map((field, index) => (
            <div className={fields.length - 1 === index ? 'col-md-12' : 'col-md-6'} key={field.id}>
              <div className="input_icon_box icon_filed_div">
                <div className="form-group mb-0 w-100">
                  <Controller
                    name={`propertyTasks.${index}.task`}
                    control={control}
                    defaultValue={field.task || ''} // Use default value from field array
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="New Task"
                          value={value}
                          onChange={(val) => {
                            onChange(val)
                            trigger(`propertyTasks.${index}.task`)
                            trigger('propertyTasks')
                          }}
                          onBlur={() => {
                            trigger(`propertyTasks.${index}.task`) // Trigger validation on blur
                            trigger('propertyTasks')
                          }}
                        />
                        {fieldState?.error && <small className="text-danger">{fieldState.error.message}</small>}
                      </>
                    )}
                  />
                </div>
                {fields.length - 1 === index ? (
                  <div className="icon_box_div add_icon" onClick={() => append({ property_cleaning_task_id: null, task: '' })}>
                    <img src={AddIcon} alt="upload" width={24} />
                  </div>
                ) : (
                  <div className="icon_box_div delete_icon" onClick={() => openDeleteModal(index)}>
                    <img src={DeleteIcon} alt="upload" width={17} />
                  </div>
                )}
              </div>
              {field.propertyTasks}
            </div>
          ))}
          {/* {error && (error?.message || error?.root?.message) && (
              <small className="text-danger">{error?.message || error?.root?.message}</small>
          )} */}
          {isDeleteModalOpen && (
            <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={() => openDeleteModal(null)}>
              <div className="multi_btn_div">
                <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
                  Cancel
                </button>
                <button type="button" className="btn btn-danger common-field-btn w-100" onClick={() => onHandleDelete()}>
                  Delete
                </button>
              </div>
            </DeletePopup>
          )}
        </div>
      </div>
    </>
  )
}

export default TasksForm
